export default __webpack_public_path__ + "static/media/aequalis24.5a8a1f7f.pdf";